import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { IGridResult } from 'src/app/core/models/base';
import { IProfile } from '../models/profile';
import { PersonalService } from '../services/personal.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileResolver  {
  constructor(private personalService: PersonalService){}

  resolve(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
    ): Observable<IProfile> {
    return this.personalService.getProfileOfCurrentUser()
      .pipe(
        map(response => {
          return {
            userName: response.userName,
            firstName: response.firstName,
            lastName: response.lastName,
            email: response.email,
            isActive: response.isActive,
            emailConfirmed: response.emailConfirmed,
            phoneNumber: response.phoneNumber,
            createdBy: response.createdBy,
            createdOn: response.createdOn,
            id: response.id
          };
        })
      )
  }
}
